export * from './codegen/base/base';
export * from './codegen/codegen';
export * from './User';
export * from './WohnhausanlageModel';
export * from './VertragModel';
export * from './TerminModel';
export * from './ZahlungModel';


// WEBPACK FOOTER //
// ./src/app/schemas/schemas.ts